import { graphql, useStaticQuery } from "gatsby"
import { locales } from "../../locales"

interface IntegrationTags {
  allStoryblokDatasourceEntry: {
    integration_tags: {
      name: string
      value: string
    }[]
  }
}

const useIntegrationTags = () => {
  const data = useStaticQuery<IntegrationTags>(graphql`{
    allStoryblokDatasourceEntry(filter: {data_source: {eq: "integration-tags"}}) {
      integration_tags: nodes {
        name
        value
      }
    }
  }`)

  // Dynamically infer languages from locales.ts
  const supportedLanguages = locales.map((locale) => locale)

  const tags = data.allStoryblokDatasourceEntry.integration_tags.map((tag) => {
    // Dynamically determine the language based on the tag value
    const lang = supportedLanguages.find((language) => tag.value.endsWith(`_${language}`)) || "default"

    return {
      lang,
      name: tag.name,
      value: tag.value,
    }
  })

  return tags
}

export default useIntegrationTags
